import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { GetArticlesRequest, GetArticlesResponse, SaveArticleRequest, Article } from '@models'

@Injectable({
  providedIn: 'root',
})
export class ArticleService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/articles`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetArticlesRequest): Promise<GetArticlesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.status !== undefined && params.status !== null) httpParams = httpParams.set('status', params.status)

      if (params.visibility) httpParams = httpParams.set('visibility', params.visibility)

      if (params.topics) httpParams = httpParams.set('topics', params.topics)

      const hasStart = !!params.startModifiedDate
      const hasEnd = !!params.endModifiedDate

      if (hasStart && hasEnd) {
        httpParams = httpParams
          .set('startModifiedDate', params.startModifiedDate!)
          .set('endModifiedDate', params.endModifiedDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetArticlesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Article> {
    const response = await firstValueFrom(this.http.get<Article>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveArticleRequest): Promise<Article> {
    const response = await firstValueFrom(this.http.post<Article>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveArticleRequest): Promise<Article> {
    const response = await firstValueFrom(this.http.put<Article>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
